import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

// Transportør-org for innlogget bruker: org-dokumentet, medlemskapet og rollen (admin, dispatcher eller driver).
// Rollen er null til medlemskapet er aktivt. En org som ikke er en transportør-org gir org null.
export function useCarrierOrg() {
  const { currentUser, userDoc } = useAuth();
  const uid = currentUser?.uid ?? null;
  const orgId = userDoc?.carrierOrgId ?? null;
  const [state, setState] = useState({ org: null, membership: null, loading: Boolean(orgId) });

  useEffect(() => {
    if (!uid || !orgId) {
      setState({ org: null, membership: null, loading: false });
      return undefined;
    }
    setState(s => ({ ...s, loading: true }));
    let org;
    let membership;
    const publish = () => {
      if (org !== undefined && membership !== undefined) setState({ org, membership, loading: false });
    };
    const unsubOrg = onSnapshot(
      doc(db, 'organizations', orgId),
      snap => {
        const data = snap.exists() ? snap.data() : null;
        org = data && data.type === 'carrier' ? { id: snap.id, ...data } : null;
        publish();
      },
      () => { org = null; publish(); },
    );
    const unsubMember = onSnapshot(
      doc(db, 'organizations', orgId, 'members', uid),
      snap => { membership = snap.exists() ? { id: snap.id, ...snap.data() } : null; publish(); },
      () => { membership = null; publish(); },
    );
    return () => { unsubOrg(); unsubMember(); };
  }, [uid, orgId]);

  const role = state.membership?.status === 'active' ? state.membership.role : null;
  return {
    orgId,
    org: state.org,
    membership: state.membership,
    role,
    isAdmin: role === 'admin',
    isStaff: role === 'admin' || role === 'dispatcher',
    isOwner: Boolean(state.org && uid && state.org.ownerUid === uid),
    loading: state.loading,
  };
}
